/* eslint-disable */
// @ts-nocheck
import { LayerExtension } from '@deck.gl/core';
import { dashAnimationShaders, gradientShaders } from 'utils/shaders';
import { PathLayer } from '@deck.gl/layers';
import { convertHexToRGBarray } from 'utils/color';
const defaultProps = {
    getDashArray: { type: 'accessor', value: [0, 0] },
};
const defaultGetPath = (d) => [
    [d.source.location.lng, d.source.location.lat],
    [d.target.location.lng, d.target.location.lat],
];
const createPathLayer = ({ data, stepId, coef, color, getPath = defaultGetPath, zoom, }) => new PathLayer({
    id: `path-layer-${stepId}`,
    data,
    coef,
    opacity: 1,
    pickable: true,
    widthScale: zoom < 12 ? 8 : 20,
    widthMinPixels: 2,
    getPath,
    getColor: () => convertHexToRGBarray(color),
    getWidth: () => 20,
    getDashArray: [8, 4],
    trailLength: 100,
    mode: 'dash', // 'gradient' || 'dash'
    extensions: [new DashGradientPathLayer()],
});
class DashGradientPathLayer extends LayerExtension {
    isEnabled(layer) {
        return layer.state.pathTesselator;
    }
    getShaders(extension) {
        if (!extension.isEnabled(this)) {
            return null;
        }
        if (this.props.mode === 'gradient')
            return gradientShaders;
        else
            return dashAnimationShaders;
    }
    initializeState(context, extension) {
        const attributeManager = this.getAttributeManager();
        if (!attributeManager || !extension.isEnabled(this)) {
            return;
        }
        extension.enabled = true;
        if (this.props.mode === 'dash') {
            attributeManager.addInstanced({
                instanceDashArrays: { size: 2, accessor: 'getDashArray' },
            });
        }
    }
    draw(opts) {
        const { coef } = this.props;
        this.state.model.setUniforms({ coef });
        if (this.props.mode === 'gradient') {
            const trailLength = this.props.trailLength;
            this.state.model.setUniforms({ trailLength });
        }
        super.draw(opts);
    }
}
DashGradientPathLayer.extensionName = 'DashGradientPathLayer';
DashGradientPathLayer.defaultProps = defaultProps;
export default createPathLayer;
